import { render } from "./CustomerChanger.vue?vue&type=template&id=05ba7006&scoped=true&ts=true"
import script from "./CustomerChanger.vue?vue&type=script&lang=ts"
export * from "./CustomerChanger.vue?vue&type=script&lang=ts"

import "./CustomerChanger.vue?vue&type=style&index=0&id=05ba7006&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ba7006"]])

export default __exports__